import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage on each request
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('hrms_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith('/login')) {
      localStorage.removeItem('hrms_token');
      // Communicate the reason so the login page can show a friendly toast.
      const detail = err.response?.data?.detail || '';
      try {
        if (/invalidated|session/i.test(detail))
          sessionStorage.setItem('hrms_force_logout', 'Your session was invalidated. Please sign in again with your new credentials.');
      } catch { /* ignore */ }
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

// File URL helper: appends auth token so the protected /files/{id} endpoint accepts it.
export function fileUrl(fid) {
  const token = localStorage.getItem('hrms_token') || '';
  return `${API}/files/${fid}?auth=${encodeURIComponent(token)}`;
}

export default api;
